/**
 * The two answers to a 409 from a scheduling route. The first attempt sends neither; each is
 * added only after the user confirmed the matching dialog, and the payload is otherwise identical.
 *
 * They are separate because the rules they override are: `force` books on top of an *overlap*
 * and flags what it displaced, `allowOutsideWorkingHours` plans a slot the technician does not
 * work — nothing is in the way there, so `force` deliberately does not cover it.
 *
 * A slot can need both: the API checks working hours before overlaps, so the same slot answers
 * 409 twice in a row and the second confirmation must carry the first override.
 */
export interface ScheduleOverrides {
  force?: boolean;
  allowOutsideWorkingHours?: boolean;
}

/** Omitted when unset, so an ordinary create stays byte-identical to what it was. */
export const overrideFields = ({ force, allowOutsideWorkingHours }: ScheduleOverrides) => ({
  ...(force ? { force: true } : {}),
  ...(allowOutsideWorkingHours ? { allowOutsideWorkingHours: true } : {}),
});
